import type { BrandSite } from "./brand-site-api";

export type BrandSiteStepTarget = "edit" | "publish" | "domain" | "external";

export type BrandSiteStepAction = {
  label: string;
  to: BrandSiteStepTarget;
  href?: string;
};

export type BrandSiteNextStep = {
  title: string;
  body: string;
  primary: BrandSiteStepAction;
  secondary?: BrandSiteStepAction;
};

/** 概览「下一步」：空站去聊，草稿去发，已上线打开站或绑域 */
export function brandSiteNextStep(site: BrandSite): BrandSiteNextStep {
  switch (site.status) {
    case "generating":
      return {
        title: "正在写官网",
        body: "可以去看看已经写出的页面，也可以继续补充想让访客看到的内容。",
        primary: { label: "看看进度", to: "edit" },
      };
    case "failed":
      return {
        title: "这一版没做出来",
        body: "再试一次，或把公司介绍说得更清楚一点。",
        primary: { label: "再试一次", to: "edit" },
      };
    case "draft_ready":
      return {
        title: "草稿可以上线了",
        body: "看过没问题就发布。以后改完再发一次就行。",
        primary: { label: "去发布", to: "publish" },
        secondary: { label: "继续改", to: "edit" },
      };
    case "published": {
      const primary: BrandSiteStepAction = site.public_url
        ? { label: "打开网站", to: "external", href: site.public_url }
        : { label: "去发布", to: "publish" };
      const secondary: BrandSiteStepAction = site.custom_host
        ? { label: "继续改", to: "edit" }
        : { label: "绑定自己的域名", to: "domain" };
      return {
        title: "已经上线",
        body: site.custom_host
          ? "访客可以从你自己的域名打开。改完内容后记得再发布一次。"
          : "先绑定自己的域名，访客才会从你的网址进来。",
        primary,
        secondary,
      };
    }
    default:
      return {
        title: "先做出一版官网",
        body: "跟右侧助手说说你们做什么、想让访客看到什么。不清楚的它会问你。",
        primary: { label: "开始做官网", to: "edit" },
      };
  }
}
